import { Dialog, DialogTitle, DialogContent, FormControl, InputLabel, Select, MenuItem, TextField, DialogActions, Button } from "@mui/material";
import { ApartmentDto } from "../../../../types/propertyInventory/Apartment";
import { Grid } from "@mui/system";
import { apartmentTypes, statusOptions } from "../../../../utils/constants";

interface Props{
    editApartmentDialogOpen: boolean;
    setEditApartmentDialogOpen: (open: boolean) => void;
    apartmentById: ApartmentDto | null;
    handleEditApartment: (updatedApartment: ApartmentDto) => void;
}

export const EditApartmentDialog: React.FC<Props> = ({ editApartmentDialogOpen, setEditApartmentDialogOpen, apartmentById, handleEditApartment }) => {
    return(
        <Dialog open={editApartmentDialogOpen} onClose={() => setEditApartmentDialogOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle>Editar Apartamento {apartmentById?.apartmentNumber}</DialogTitle>
                <DialogContent>
                  <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid size={{xs:12, sm:6}}>
                      <FormControl fullWidth>
                        <InputLabel>Tipo de Apartamento</InputLabel>
                        <Select
                          defaultValue={apartmentById?.apartmentType}
                          label="Tipo de Apartamento"
                        >
                          {apartmentTypes.map((type ) => (
                            <MenuItem key={type.value} value={type.value}>{type.label}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid size={{xs:12, sm:6}}>
                      <TextField
                        fullWidth
                        label="Precio Mensual"
                        type="number"
                        defaultValue={apartmentById?.baseRentAmount}
                      />
                    </Grid>
                    <Grid size={{xs:12, sm:6}}>
                      <TextField
                        fullWidth
                        label="Fecha de Pago"
                        type="date"
                        defaultValue={apartmentById?.currentTenant?.createdAt ? new Date(apartmentById.currentTenant.createdAt).toISOString().split('T')[0] : ''}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid size={{xs:12, sm:6}}>
                      <FormControl fullWidth>
                        <InputLabel>Estado</InputLabel>
                        <Select
                          defaultValue={apartmentById?.status}
                          label="Estado"
                        >
                          {statusOptions.map((status) => (
                            <MenuItem key={status.value} value={status.value}>{status.label}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setEditApartmentDialogOpen(false)}>Cancelar</Button>
                  <Button onClick={() => { if (apartmentById) handleEditApartment(apartmentById); }} variant="outlined" sx={{ backgroundColor: '#4DB6AC' }}>
                    Guardar Cambios
                  </Button>
                </DialogActions>
              </Dialog>
    )
};